import React from 'react';
import isFunction from 'lodash/isFunction';
import Analytics from '../utils/Analytics';
import { SegmentEventTypes } from '../data/tracking';
import Typography from './Typography.component';

const Link = props => {
	const { children, onClick, navIcon = false, className, ...rest } = props;

	const clickHandler = e => {
		const { dataqa = 'common' } = props;
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'link',
				field_name_dataqa: `ui-link-${dataqa}`,
			},
			eventType: SegmentEventTypes.UserInteraction,
		});

		if (isFunction(onClick)) {
			onClick(e);
		}
	};

	return (
		<a
			className={`common-ui-link ${className}`}
			onClick={clickHandler}
			{...rest}
			role="button"
			tabIndex={0}
		>
			<Typography.P>{children}</Typography.P>
			{navIcon && ' '}
			{navIcon && <Typography.P className="external-link-icon" />}
		</a>
	);
};

export default Link;
